<!--
@Author: DKing
@Desc: 解决方案-及时配送行业
@Date: 2021-04-22
-->
<template>
  <div>
    <div class="banner-box">
      <p class="title">即时配送行业解决方案</p>
      <p class="btnFullColor" @click="jumpPage">立即咨询</p>
    </div>

    <!-- 场景诉求 -->
    <div class="section1">
      <div class="title-txt">场景诉求</div>
      <div class="content content1">
        <img src="./../../../static/pc/解决方案/icon_solution_qiyesuqiu@2x.png" alt="">
        <span class="title">企业诉求</span>
        <div class="txt-content">
          企业人力成本降低、获取合规票据
        </div>
      </div>
      <div class="content content2">
        <img src="./../../../static/pc/解决方案/icon_solution_peisongsuqiu.png" alt="">
        <span class="title">配送人员诉求</span>
        <div class="txt-content">
          为了多赚钱，到手钱多； <br>
          意外受伤有保证；<br>
          老家有社保、新农合；获得尊重
        </div>
      </div>
    </div>

    <div class="min-width-pc">
      <div class="title-txt">即时配送行业解决方案</div>
      <div class="product-container">
        <div class="item">
          <img style="margin-right:90px;" class="product-img" src="./../../../static/pc/解决方案/img_solution_22.png" alt="">

          <div class="product-text">
            <p class="title">
              「企业+平台+新个体」 <br> 新经济合作模式
            </p>
            <p class="text">
              慧用工帮助灵活就业者注册成为新个体
            </p>
          </div>
        </div>

        <div class="item">
          <div class="product-text">
            <p class="title">
              「个人向个体工商户转型，合理享受个人税收优惠」
            </p>
            <p class="text">
              企业组织架构优化，降低人力用工成本，业务、票据、资金相匹配，银行监管，资金安全无忧
            </p>
          </div>

          <img style="margin-left:27px;" class="product-img" src="./../../../static/pc/解决方案/img_solution_23@2x.png" alt="">
        </div>
      </div>

      <div class="title-txt">慧用工方案优势</div>
      <div class="case-box">
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_231@2x.png" alt="">
          <div class="text-box">
            <p class="title">组织结构优化</p>
            <p>
              帮助配送人员向个体工商户转型；助力企业人资组织结构优化，打造创新型新业态企业
            </p>
          </div>
        </div>
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_32@2x.png" alt="">
          <div class="text-box">
            <p class="title">成本优化</p>
            <p>
              降低企业运营管理成本，降低企业用工成本，提高个人收入
            </p>
          </div>
        </div>
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_233.png" alt="">
          <div class="text-box">
            <p class="title">简单高效</p>
            <p>
              全线上化智能注册系统，两分钟完成线上注册，最快当天出营业执照
            </p>
          </div>
        </div>
        <div class="case-item">
          <img src="./../../../static/pc/解决方案/icon_solution_34@2x.png" alt="">
          <div class="text-box">
            <p class="title">资金安全</p>
            <p>
              我们与招商及网商银行建立合作，共管账户、专款专用、秒级结算到账（可结算至个人银行账户、微信钱包余额、支付宝账户），保障客户的资金安全
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗form -->
    <pc-form-dialog :source='source'><span class="pc-form-text">慧用工｜致力于助力每一个优秀的公司</span></pc-form-dialog>
    <!-- 底部悬浮框 -->
    <pc-suspension-dialog :source="sourceF"></pc-suspension-dialog>
    
  </div>
</template>

<script type="text/javascript">
import pcFormDialog from '../../components/pcFormDialog.vue'
import pcSuspensionDialog from "../../components/pcSuspensionDialog";

export default {
  name: "solution-timelyDist",
  data() {
    return {
      pageSource: 'solutionTimelyDist',
      source:'',
      sourceF:'',
    }
  },

  components: {
    "pc-form-dialog": pcFormDialog,
    "pc-suspension-dialog": pcSuspensionDialog
  },
  
  created() {
     // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=jjfa_jsps' : '&pageFrom=jjfa_jsps';
    this.sourceF = this.source + "_f";
  },

  methods: {
    jumpPage(){
      eventBus.$emit("pcOperaDiaLog", true);
    },
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  background:url('./../../../static/pc/解决方案/banner_solution_2.png') no-repeat;
  background-color: #100f0f;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
}
.section1{
  width:100%;
  padding-top:88px;
  margin-bottom: 88px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(25, 133, 255, 0.09) 100%);
  // background-image: linear-gradient(to bottom, rgb(250,250,250),  rgba(25, 133, 255, 0.15));
  .content{
    width:540px;
    height: 351px;
    background-color: #FFFFFF;
    box-shadow: 0px -10px 84px -20px rgba(5, 50, 102, 0.07);
    display: inline-block;
    margin-top: 95px;
    position: relative;
    padding:48px 40px;
    vertical-align: middle;
    img{
      width:36px;
      height: 36px;
      margin-right:12px;
      vertical-align: middle;
    }
    .title{
      color: rgba(23, 30, 46, 100);
      font-size: 24px;
      // font-family: AlibabaPuHuiTi-Medium;
      font-weight: bold;
      display: inline-block;
      height: 36px;
      line-height: 36px;
      vertical-align: middle;
    }
    .txt-content{
      margin-top:60px;
      text-align: center;
      color: rgba(112, 111, 111, 100);
      font-size: 24px;
      position: relative;
      padding:40px 45px;
      &::before{
        content: '';
        display: inline-block;
        width: 40px;
        height: 50px;
        background: url('./../../../static/pc/解决方案/icom_yinhao_1@2x.png') no-repeat;
        position: absolute;
        left:0;
        top:0px;
      }
      &::after{
        content: '';
        display: inline-block;
        width: 40px;
        height: 50px;
        background: url('./../../../static/pc/解决方案/icom_yinhao_2@2x.png') no-repeat;
        position: absolute;
        right:0;
        bottom: 0px;
      }
    }
  }
  .content1{
    margin-right:20px;
  }
  .content1::before{
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left:-50px;
    width: 50px;
    height: 270px;
    background: url('./../../../static/pc/解决方案/img_solution_bg_1.png') no-repeat;
  }
  .content2::after{
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    right:-50px;
    width: 50px;
    height: 270px;
    background: url('./../../../static/pc/解决方案/img_solution_bg_1.png') no-repeat;
  }
}

.product-container{
  margin-top: 96px;
  .item{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 80px;
    .product-text{
      width:495px;
      text-align: left;
      .title{
        color: rgba(64, 63, 63, 100);
        font-size: 24px;
        // font-family: AlibabaPuHuiTi-Medium;
        margin-bottom: 20px;
        font-weight: bold;
        position: relative;
        padding-bottom: 22px;
        &::after{
          content: '';
          width: 24px;
          height: 4px;
          display: block;
          border-radius: 16px;
          position: absolute;
          bottom: 0;
          background-color: rgba(25, 133, 255, 1);
        }
      }
      .text{
        line-height: 36px;
        color: rgba(64, 63, 63, 100);
        font-size: 14px;
      }
    }

    .product-img{
      width: 805px;
    }

  }
}

.case-box{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 77px;
  margin-bottom: 93px;
  .case-item{
    width:580px;
    height: 208px;
    display: inline-flex;
    padding:30px 20px 0 30px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    box-sizing: border-box;
    &:hover{
      position: relative;
      top:-5px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 20px 20px 0px rgba(16, 15, 15, 0.09);
    }
    img{
      width: 50px;
      height: 50px;
      vertical-align: top;
      margin-right:30px;
    }
    .text-box{
      line-height: 32px;
      color: rgba(64, 63, 63, 100);
      font-size: 18px;
      text-align: left;
      .title{
        color: rgba(16, 15, 15, 100);
        font-size: 24px;
        text-align: center;
        // font-family: AlibabaPuHuiTi-Medium;
        font-weight: bold;
        text-align: left;
        margin-bottom: 20px;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/views/pc/solution_timelyDist.vue